export enum CommentState {
    PUBLISHED = 89,
    DRAFT = 90,
    DELETED = 91,
    REMOBED = 92
}